// File storage utility to persist files in memory during the app session

// Create a singleton file map that persists throughout the app session
class FileStorage {
  private static instance: FileStorage
  private fileMap: Record<string, File> = {}

  public static getInstance(): FileStorage {
    if (!FileStorage.instance) {
      FileStorage.instance = new FileStorage()
    }
    return FileStorage.instance
  }

  // Add a file to storage
  public addFile(id: string, file: File): void {
    this.fileMap[id] = file
  }

  // Get a file from storage
  public getFile(id: string): File | undefined {
    return this.fileMap[id]
  }

  // Remove a file from storage
  public removeFile(id: string): void {
    if (this.fileMap[id]) {
      delete this.fileMap[id]
    }
  }

  // Clear all files from storage
  public clearFiles(): void {
    this.fileMap = {}
  }

  // Check if a file exists in storage
  public hasFile(id: string): boolean {
    return !!this.fileMap[id]
  }

  // Get all file IDs
  public getFileIds(): string[] {
    return Object.keys(this.fileMap)
  }
}

// Export a singleton instance
export const fileStorage = FileStorage.getInstance()
